<template>
    <div class="card-diagram-info d-flex justify-content-between mr-n15px mb-4  flex-sm-row">
        <h2 class="">{{textHeader}}</h2>
        <div class="wrapper-btn" v-if="checkIfVisible()">
            <b-button variant="primary"
                      class="custom px-4 px-md-5" :to="{ name: route }">
                <span class="icon icon-plus pr-2"></span>
                {{textButton}}
            </b-button>
        </div>
    </div>
</template>

<script>
import { checkUserPermissions } from '@/config/AppConfig'
export default {
  props: ['route', 'textHeader', 'textButton', 'permissionParam'],
  methods: {
    checkIfVisible () {
      if (this.textButton === undefined) {
        return false
      }
      if (this.permissionParam !== undefined && this.permissionParam !== null) {
        return checkUserPermissions(this.permissionParam)
      }
      return true
    }
  }
}
</script>
